
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/api-page",
      function () {
        return require("private-next-pages/api-page/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/api-page"])
      });
    }
  